import { FormStepAbstract } from '../../../../../shared/components/abstract/form-step.abstract';
import { FormControl } from '@angular/forms';
import { IAddressControl } from '../../../../../pages/ordering/interfaces/address-control.interface';
import { Observable, tap } from 'rxjs';
import { DeliveryType } from '../../../../../api/v1/models/delivery-type';
import { Outlet } from '../../../../../api/v1/models/outlet';
import { MatSelect } from '@angular/material/select';
import { SessionRepository } from '../../../../../shared/repositories/session.repository';
import { ConfigRepository } from '../../../../../shared/repositories/config.repository';
import { inject } from '@angular/core';

export class AddressSelectorAbstract extends FormStepAbstract {
  private sessionRepository: SessionRepository = inject(SessionRepository);
  private config: ConfigRepository = inject(ConfigRepository);

  override form: FormControl<IAddressControl | null> = new FormControl<IAddressControl | null>(null);

  selectedDeliveryType$: Observable<DeliveryType | null> = this.sessionRepository.selectedDeliveryType$;
  deliveryType = DeliveryType;

  restoSelectCtrl: FormControl<number | null> = new FormControl<number | null>(null);

  activeOutletId$: Observable<number | undefined> = this.config.activeOutletId$.pipe(
    tap(id => this.restoSelectCtrl.setValue(id || null))
  )

  pickupAddress$ = this.config.address$;
  outlets$: Observable<Outlet[]> = this.sessionRepository.applicableOutlets$;
  addressFieldSettings$ = this.config.addressFieldSettings$

  onChangeResto(matSelect: MatSelect): void {
    this.config.setActiveOutlet(matSelect.value);
  }
}
